import { render } from "./Content.vue?vue&type=template&id=72db2a94"
const script = {}

import exportComponent from "/Users/jirizavadil/dev/tumorshot-web/app/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])